import { useState, useEffect } from "react";
import { FORM_ID } from "../../../../constants/Forms";
import { Col, Row } from "react-bootstrap";
import LostDataModal from "../../../SharedComponents/LostDataModal";
import { insertAdditionalInformation } from "../../../../api/makeAPIRequest";
import NavigationButtons from "../../../SharedComponents/NavigationButtons";
import SectionTitle from "../../../SharedComponents/SectionTitle";
import "./PersonalInfoAddlForm.scss";
import { useDispatch } from "react-redux";
import { additionalInfoActions } from "../../../../store/actions";
import { connect } from "react-redux";

const CoveredAdvisorCertificate = ({
  retainedaccess,
  legaladvice,
  discloseddata,
  pInfoAddlData,
  savePersonalInfoAdditionalInfo,
  toggleForm,
  isFormComplete,
  subId,
  hasCurrentFormChanged,
  candidateId,
  contractId,
}) => {
  const [formHasError, setFormHasError] = useState(false);
  const [formHasChanged, setFormHasChanged] = useState(false);
  const [showBackModal, setShowBackModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  var hasError = false;
  var hasChange = false;

  const handleErrorDisplay = (fieldId, show) => {
    hasChange = true;
    setFormHasError(false);
    setFormHasChanged(true);
    isFormComplete(false);
    hasCurrentFormChanged(true);
    if (fieldId === "retainedaccess") {
      let retainedaccess_error = document.getElementById(
        "retained_access_error"
      );
      retainedaccess_error.style.display = show ? "block" : "none";
      let retainedaccess_yes = document.getElementById("retained_access_yes");
      retainedaccess_yes.classList.toggle("is-invalid", show);
      let retainedaccess_no = document.getElementById("retained_access_no");
      retainedaccess_no.classList.toggle("is-invalid", show);
    }
    if (fieldId === "discloseddata") {
      let discloseddata_error = document.getElementById("disclosed_data_error");
      discloseddata_error.style.display = show ? "block" : "none";
      let discloseddata_yes = document.getElementById("disclosed_data_yes");
      discloseddata_yes.classList.toggle("is-invalid", show);
      let discloseddata_no = document.getElementById("disclosed_data_no");
      discloseddata_no.classList.toggle("is-invalid", show);
    }
    if (fieldId === "legaladvice") {
      let legaladvice_error = document.getElementById("legal_advice_error");
      legaladvice_error.style.display = show ? "block" : "none";
      let legaladvice_yes = document.getElementById("legal_advice_yes");
      legaladvice_yes.classList.toggle("is-invalid", show);
      let legaladvice_no = document.getElementById("legal_advice_no");
      legaladvice_no.classList.toggle("is-invalid", show);
    }
  };

  const handleCloseBackModal = () => {
    setShowBackModal(false);
  };

  const handleBackClick = () => {
    handleCloseBackModal();
    toggleForm(FORM_ID.PERSONAL_INFO_ADDITIONAL_INFO);
  };

  const handleShowBackModal = () => {
    if (formHasChanged) {
      setShowBackModal(true);
    } else {
      toggleForm(FORM_ID.PERSONAL_INFO_ADDITIONAL_INFO);
    }
  };

  const handleCertificateChange = (field, value) => {
    setFormHasChanged(true);
    setFormHasError(false);
    handleErrorDisplay(field, false);
    hasChange = true;
    isFormComplete(false);
    hasCurrentFormChanged(true);
    dispatch(
      additionalInfoActions.setCoveredAdvisorCertificate({
        coveredAdvisorCertificate: {
          [field]: value,
        },
      })
    );
  };

  const callApi = async () => {
    const data = {
      candidateid: candidateId,
      retainedaccess: retainedaccess === "Y" ? true : false,
      legaladvice: legaladvice === "Y" ? true : false,
      discloseddata: discloseddata === "Y" ? true : false,
    };
    savePersonalInfoAdditionalInfo([
      {
        ...data,
        oktasubid: subId,
      },
    ]);
    insertAdditionalInformation(subId, contractId, data);
    setLoading(false);
    hasChange = false;
  };

  const handleNext = async () => {
    setFormHasError(false);

    if (retainedaccess === "" || undefined || null) {
      hasError = true;
      setFormHasError(true);
      let retainedaccess = document.getElementById("retained_access_error");
      retainedaccess.style.display = "block";
      let retainedaccessYes = document.getElementById("retained_access_yes");
      retainedaccessYes.classList.add("is-invalid");
      let retainedaccessNo = document.getElementById("retained_access_no");
      retainedaccessNo.classList.add("is-invalid");
      let label_yes = document.getElementById("label_retained_access_yes");
      label_yes.style.color = "#555";
      let label_no = document.getElementById("label_retained_access_no");
      label_no.style.color = "#555";
    }

    if (discloseddata === "" || undefined || null) {
      hasError = true;
      setFormHasError(true);
      let discloseddata = document.getElementById("disclosed_data_error");
      discloseddata.style.display = "block";
      let discloseddataYes = document.getElementById("disclosed_data_yes");
      discloseddataYes.classList.add("is-invalid");
      let discloseddataNo = document.getElementById("disclosed_data_no");
      discloseddataNo.classList.add("is-invalid");
      let label_yes = document.getElementById("label_disclosed_data_yes");
      label_yes.style.color = "#555";
      let label_no = document.getElementById("label_disclosed_data_no");
      label_no.style.color = "#555";
    }

    if (legaladvice === "" || undefined || null) {
      hasError = true;
      setFormHasError(true);
      let legalAdvice = document.getElementById("legal_advice_error");
      legalAdvice.style.display = "block";
      let legalAdviceYes = document.getElementById("legal_advice_yes");
      legalAdviceYes.classList.add("is-invalid");
      let legalAdviceNo = document.getElementById("legal_advice_no");
      legalAdviceNo.classList.add("is-invalid");
      let label_yes = document.getElementById("label_legal_advice_yes");
      label_yes.style.color = "#555";
      let label_no = document.getElementById("label_legal_advice_no");
      label_no.style.color = "#555";
    }

    if (formHasChanged && !hasError) {
      await callApi();
    }

    if (
      !hasError &&
      !hasChange &&
      legaladvice !== "" &&
      discloseddata !== "" &&
      retainedaccess !== ""
    ) {
      toggleForm(FORM_ID.RESIDENTIAL_HISTORY);
      isFormComplete(true);
      hasCurrentFormChanged(false);
    }
  };

  const fetch = async () => {
    const data = pInfoAddlData;

    if (data?.length > 0 && data !== undefined) {
      let val = data[0];
      if (
        (val.retainedaccess === null || val.retainedaccess === undefined) &&
        (val.legaladvice === null  || val.legaladvice === undefined) &&
        (val.discloseddata === null || val.discloseddata === undefined)
      ) {
        isFormComplete(false);
      } else {
        isFormComplete(true);
      }

      dispatch(
        additionalInfoActions.setCoveredAdvisorCertificate({
          coveredAdvisorCertificate: {
            legaladvice: val.legaladvice
              ? "Y"
              : (val.legaladvice === null || val.legaladvice === undefined)
                ? ""
                : "N",
          },
        })
      );

      dispatch(
        additionalInfoActions.setCoveredAdvisorCertificate({
          coveredAdvisorCertificate: {
            retainedaccess: val.retainedaccess
              ? "Y"
              : (val.retainedaccess === null || val.retainedaccess === undefined)
                ? ""
                : "N",
          },
        })
      );

      dispatch(
        additionalInfoActions.setCoveredAdvisorCertificate({
          coveredAdvisorCertificate: {
            discloseddata: val.discloseddata
              ? "Y"
              : (val.discloseddata === null || val.discloseddata === undefined)
                ? ""
                : "N",
          },
        })
      );
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  return (
    <div id="additionalInfoForm">
      <SectionTitle
        titleID="addtnlInfo"
        titleName="Covered Advisor Onboarding Certification"
      ></SectionTitle>
      <Row>
        <Col sm={12}>
          <h3>
            I certify that I have not, directly or indirectly, retained and do
            not have direct or indirect access to originals or copies of any
            hard copy or electronic client files, client data, or client records
            that my prior firm’s rules prohibit me from retaining or accessing.*
          </h3>
          <div className="custom-control">
            <div className="custom-control custom-radio" id="retainedaccess">
              <input
                type="radio"
                name="retained_access"
                id="retained_access_yes"
                className="custom-control-input"
                checked={retainedaccess === "Y"}
                value="Y"
                onChange={(e) =>
                  handleCertificateChange("retainedaccess", e.target.value)
                }
              />
              <label
                htmlFor="retained_access_yes"
                className="custom-control-label"
                id="label_retained_access_yes"
              >
                Yes
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                name="retained_access"
                className="custom-control-input"
                id="retained_access_no"
                checked={retainedaccess === "N"}
                value="N"
                onChange={(e) =>
                  handleCertificateChange("retainedaccess", e.target.value)
                }
              />
              <label
                htmlFor="retained_access_no"
                className="custom-control-label"
                id="label_retained_access_no"
              >
                No
              </label>
            </div>
            <div id="retained_access_error" className="invalid-feedback">
              Please choose a response
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <h3>
            I certify that I have disclosed to the listed Agency all electronic
            and hard copy storage facilities that I use to maintain client
            files, client data and client records (including, for example, any
            such files I maintain in a Windows folder, Box.com, or SalesForce).
            I also acknowledge that the Agency Head and compliance personnel at
            the above listed Agency, including their successors, have the right
            to access, review, and audit any such storage facilities.*
          </h3>
          <div className="custom-control">
            <div className="custom-control custom-radio" id="finra">
              <input
                type="radio"
                name="disclosed_data"
                id="disclosed_data_yes"
                className="custom-control-input"
                checked={discloseddata === "Y"}
                value="Y"
                onChange={(e) =>
                  handleCertificateChange("discloseddata", e.target.value)
                }
              />
              <label
                htmlFor="disclosed_data_yes"
                className="custom-control-label"
                id="label_disclosed_data_yes"
              >
                Yes
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                name="disclosed_data"
                className="custom-control-input"
                id="disclosed_data_no"
                checked={discloseddata === "N"}
                value="N"
                onChange={(e) =>
                  handleCertificateChange("discloseddata", e.target.value)
                }
              />
              <label
                htmlFor="disclosed_data_no"
                className="custom-control-label"
                id="label_disclosed_data_no"
              >
                No
              </label>
            </div>
            <div id="disclosed_data_error" className="invalid-feedback">
              Please choose a response
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <h3>
            I understand that I may seek independent legal advice (at my own
            cost) regarding my rights and obligations concerning my access to
            client files, client data, or client records from my prior firm, as
            well as any non-compete or other restrictive covenants that may
            apply to me.*
          </h3>
          <div className="custom-control">
            <div className="custom-control custom-radio">
              <input
                type="radio"
                name="legal_advice"
                id="legal_advice_yes"
                className="custom-control-input"
                checked={legaladvice === "Y"}
                value="Y"
                onChange={(e) =>
                  handleCertificateChange("legaladvice", e.target.value)
                }
              />
              <label
                htmlFor="legal_advice_yes"
                className="custom-control-label"
                id="label_legal_advice_yes"
              >
                Yes
              </label>
            </div>
            <div className="custom-control custom-radio">
              <input
                type="radio"
                name="legal_advice"
                className="custom-control-input"
                id="legal_advice_no"
                checked={legaladvice === "N"}
                value="N"
                onChange={(e) =>
                  handleCertificateChange("legaladvice", e.target.value)
                }
              />
              <label
                htmlFor="legal_advice_no"
                className="custom-control-label"
                id="label_legal_advice_no"
              >
                No
              </label>
            </div>
            <div id="legal_advice_error" className="invalid-feedback">
              Please choose a response
            </div>
          </div>
        </Col>
      </Row>

      <NavigationButtons
        onBack={handleShowBackModal}
        onNext={handleNext}
        isLoading={loading}
        nxtbtnid={"nxtaddtlbtn"}
        bckbtnid={"bckaddlbtn"}
      />

      <LostDataModal
        isOpen={showBackModal}
        handleClose={handleCloseBackModal}
        handleProceed={handleBackClick}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    retainedaccess:
      state.additionalInfoPageInitialState.coveredAdvisorCertificate
        .retainedaccess,
    legaladvice:
      state.additionalInfoPageInitialState.coveredAdvisorCertificate
        .legaladvice,
    discloseddata:
      state.additionalInfoPageInitialState.coveredAdvisorCertificate
        .discloseddata,
  };
};

export default connect(mapStateToProps)(CoveredAdvisorCertificate);
